export const datosGraficaPorHoras = {
  type: 'line',
  data: {
    labels: ['Trading por horas', 'Martes', 'Miercoles', 'Mars', 'Jupiter', 'Saturn', 'Uranus', 'Neptune'],
    datasets: [
      { // one line graph
        label: 'Porcentaje de disponibilidad por horas',
        data: [0, 0, 1, 2, 67, 62, 27, 14],
        backgroundColor: 'rgba(27, 107, 157, .4)',
        borderColor: 'rgba(27, 107, 157, 1)',
        borderWidth: 2
      },

    ]
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    lineTension: 0,
    scales: {
      yAxes: [{
        ticks: {
          callback: function (value) {
            return value + " %";
          },

          min: 0,
          max: 100,
          beginAtZero: true
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        }
      }],
      xAxes: [{
        ticks: {
          autoSkip: false,

        }
      }]
    },
    tooltips: {
      callbacks: {

        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
          return label + ' %';
        },
      }
    }
  }
}

export default datosGraficaPorHoras;